<!--团队介绍-->
<template>
  <div class="newlist2 flex_column">
    <li v-for="(item, index) in data" :key="index">
      <div class="img"><img :src="item.picture"></div>
      <div class="right">
        <b>{{item.name}}</b>
        <div class="text">{{item.remark}}</div>
      </div>
    </li>
  </div>

</template>

<script>
import api from '@/apis/CompanyProfile'
export default {
  data() {
    return {
      data: [
        {
          id: 0,
          name: '黄联禧 先生',
          picture: require('@/assets/images/pic2.png'),
          remark: '中国联塑公布2020年全年业绩：塑料管道系统业务持续攀升，实现整体业绩逆势增长。收入和本公司拥有人应占溢利分别同比增长6.6%和24.0%',
        },
        {
          id: 1,
          name: '黄联禧 先生',
          picture: require('@/assets/images/pic3.png'),
          remark: '中国联塑公布2020年全年业绩：中国联塑公布2020年全年业绩：塑料管道系统业务持续攀升，实现整体业绩逆势增长。收入和本公司拥有人应占溢利分别同比增长6塑料管道系统业务持续攀升，实现整体业绩逆势增长。收入和本公司拥有人应占溢利分别同比增长6.6%和24.0%',
        },
      ],
      timer: null,
    }
  },
  methods: {
    scroll() {
      document.querySelector('.newlist2  li').style =
        'transition: all 0.2s;margin-top: -' +
        document.querySelector('.newlist2  li').clientHeight +
        'px;'
      setTimeout(() => {
        this.data.push(this.data.shift())
        document.querySelector('.newlist2  li').style = ''
      }, 200)
    },
  },
  mounted() {

    api.team({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          this.data = res.data.list
          if (this.data.length>1) {
            this.timer = setInterval(this.scroll, 4000)
          }
        } else {
          this.$message.error(res.message)
        }
      })


  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="less" scoped>
.newlist2 {
  padding: 0px 0.71rem 0.71rem;
  height: 100%;
  overflow: hidden;
  li {
    height: 4.7rem; flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items:flex-end;
    width: 100%;
    overflow: hidden;
    margin-top: 0.5rem;
    .img {
      width: 4.5rem;
      height: 100%;
      margin-right: 0.8rem;
      overflow: hidden;
      flex-shrink: 0;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .right {
      flex: 1;
      height: 100%;
      overflow: hidden;
      b {
        display: block;
        font-weight: 400;
        font-size: 0.8rem;
        color: #05f8fc;
        margin-top: 4px;
        margin-bottom: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .text {
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.65rem;
        height: 3.2rem;
        line-height: 1rem;
      }
    }
  }
}
</style>